/**
 * Central `data-testid` values shared by the React app (Vite) and Playwright E2E (Node).
 * No browser-only imports — safe in both runtimes.
 */
export enum TestId {
  LoginSubmit = "login-submit",
  LoginMethodEmail = "login-method-email",
  LoginMethodPhone = "login-method-phone",
  SwitchToCodeLogin = "switch-to-code-login",
  SwitchToPasswordLogin = "switch-to-password-login",
  VideoCreatingFlow = "video-creating-flow",
  ProductLinkInput = "product-link-input",
  VideoBasicNextButton = "video-basic-next-button",
  VideoImageUploadItem = "video-image-upload-item",
  VideoImageCaptionTrigger = "video-image-caption-trigger",
  VideoImageCaptionInput = "video-image-caption-input",
  VideoImageCaptionSave = "video-image-caption-save",
  VideoDurationSelect = "video-duration-select",
  VideoResolutionSelect = "video-resolution-select",
  VideoModelSelect = "video-model-select",
  ScriptRewriteGenerate = "script-rewrite-generate",
  VideoScriptGenerateButton = "video-script-generate-button",
  MemberPopoverCreditsRemaining = "member-popover-credits-remaining",
  LibraryGeneratedVideoCard = "library-generated-video-card",
  LibraryGeneratedVideoExport = "library-generated-video-export",
  LibraryGeneratedVideoDetailExport = "library-generated-video-detail-export",
  LibraryGeneratedVideoDownload = "library-generated-video-download",
  LibraryGeneratedVideoDownloadLoading = "library-generated-video-download-loading",
  LibraryGeneratedVideoPostToTikTok = "library-generated-video-post-to-tiktok",
  PostToTikTokModal = "post-to-tiktok-modal",
  PostToTikTokModalClose = "post-to-tiktok-modal-close",
  PostToTikTokAccountSelect = "post-to-tiktok-account-select",
  PostToTikTokProductSelect = "post-to-tiktok-product-select",
  PostToTikTokProductPickerPopup = "post-to-tiktok-product-picker-popup",
  PostToTikTokProductOption = "post-to-tiktok-product-option",
  PostToTikTokDescription = "post-to-tiktok-description",
  PostToTikTokShortTitle = "post-to-tiktok-short-title",
  PostToTikTokTitleBannedError = "post-to-tiktok-title-banned-error",
  PostToTikTokSubmit = "post-to-tiktok-submit",
  SchedulePostSwitch = "schedule-post-switch",
  SchedulePostDatePicker = "schedule-post-date-picker",
  SchedulePostDatePickerDropdown = "schedule-post-date-picker-dropdown",
  SchedulePostTimezoneLabel = "schedule-post-timezone-label",
  SchedulePostError = "schedule-post-error",
  SocialPublisherPostVideo = "social-publisher-post-video",
  PostVideoModal = "post-video-modal",
  PostVideoModalClose = "post-video-modal-close",
  PostVideoSourceTabLibrary = "post-video-source-tab-library",
  PostVideoSourceTabVideoFile = "post-video-source-tab-video-file",
  PostVideoLibrarySubTabGenerated = "post-video-library-subtab-generated",
  PostVideoLibrarySubTabUploaded = "post-video-library-subtab-uploaded",
  PostVideoLibraryCard = "post-video-library-card",
  PostVideoModalSubmit = "post-video-modal-submit",
  VideoCreateParseErrorTip = "video-create-parse-error-tip",
}
